import { useApi } from '../api/useApi';
import { UserLifecycleActionPage } from '../features/users/UserLifecycleActionPage';

export function BlockUserPage() {
  const api = useApi();
  return (
    <UserLifecycleActionPage
      title="Benutzer sperren"
      description="Konto deaktivieren — die Anmeldung wird unterbunden (reversibel)."
      pageKey="users.block"
      confirmLabel="Sperren"
      action={(id, ticket) => api.blockUser(id, ticket)}
    />
  );
}
